import { FieldType } from '@wix/wix-data-schema-types'
import {
  CHECKBOX_ROLE,
  USER_INPUT_FILTER_V1_ROLE,
  USER_INPUT_FILTER_CHECKBOX_ROLE,
} from '@wix/wix-data-client-common-standalone'
import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'

const { boolean } = FieldType

export default (): DataBindingComponentModel => ({
  componentName: 'Element_Name_Checkbox',
  isConnectGfppEnabled: true,
  supportsDefaultSelectedDataset: true,
  panel: {
    height: 297,
    title: 'Connect_Panel_Title_Checkbox',
    helpId: 'aab94d19-74fb-4ec6-a487-2445e3706842',
    chooseScreenHelpId: 'cbd1cce8-0d4e-48e3-8283-5412c54cb578',
    submitContentHelpId: '19da9e04-3095-4cd1-9365-c6e52534e898',
    userInputFilterHelpId: 'f6f107a0-d096-4297-948a-1d96160b753a',
  },
  sections: [
    {
      role: CHECKBOX_ROLE,
      bindings: [
        {
          title: 'Connect_Panel_Connect_Checked_Value_Label',
          prop: 'checked',
          supportedFieldTypes: [boolean],
          defaultFieldType: boolean,
          isInputProperty: true,
        },
      ],
    },
    {
      role: USER_INPUT_FILTER_V1_ROLE,
      bindings: [],
      componentTypeName:
        'Connect_Panel_Dataset_Filter_Message_Element_Type_Checkbox',
    },
    {
      role: USER_INPUT_FILTER_CHECKBOX_ROLE,
      isUserInputFilter: true,
      bindings: [
        {
          prop: 'checked',
          supportedFieldTypes: [boolean],
          defaultFieldType: boolean,
        },
      ],
    },
  ],
  compactErrorPanel: true,
})
